export const font = {
  xxSmall: '0.5rem',
  xSmall: '0.75rem',
  small: '0.875rem',
  medium: '1rem',
  large: '1.125rem',
  xLarge: '2.25rem',
  xxLarge: '3.75rem',
};
